//App.js

import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Protected from './components/Protected';
import { AuthContextProvider } from './context/AuthContext';
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Home from "./pages/Home/Home";
import Header from "./components/header"
import OpenShop from './pages/Dashboard/OpenShop';
import CloseShop from './pages/Dashboard/CloseShop';
import FormDash from './pages/Dashboard/FormDash';

function App() {
  return (
    <div>
      <AuthContextProvider>
        <Header/>
        <Routes>
          <Route path="/" element={ <Home/> } />
          <Route path="login" element={ <Login/> } />
          <Route path="home" element={ <Home/> } />
          <Route path="dashboard" element={ <Protected> <Dashboard/></Protected> } />
          <Route path="dashboard/FormDash" element={<Protected><FormDash /></Protected>} />
          <Route path="dashboard/openshop" element={<Protected><OpenShop /></Protected>} />
        </Routes>
      </AuthContextProvider>

    </div>
  );
}


export default App;
